import { useDispatch } from "react-redux";
import oldStyle from './styles.js';
import { Box, Button, ButtonGroup, CircularProgress, Grid, TextField, useMediaQuery, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import useStyles from '../../../styles/global-mui.js';
import { getMatchDetail } from "../../../actions/matchDetail.js";
import LiveHeader from "../header/LiveHeader.js";
import TabPanel from "../../../dsasComponents/TabPanel.js";
import GameFact from "../gameFact/GameFact.js";
import GameFactFilter from "../gameFact/GameFactFilter.js";
import LiveSaisieRapide from "../saisierapide/LiveSaisieRapide.js";
import LiveImport from "../import/LiveImport.js";
import LiveHistorique from "../historique/LiveHistorique.js";
import { updateInfoMatch} from "../../../actions/matchs.js";
import ReactCrop from "react-image-crop";

import background from '../../../images/live/header_vf.png'
import background_handball from '../../../images/live/handball.png'
import FeuilleMatchCreation from "../../../dsasComponents/feuillematch/FeuilleMatchCreation.js";
import { getSurchargePeriod } from "../sports/rules.js";
import DsasButton from "../../../v1/components/DsasButton/DsasButton.js";
import { faImage } from "@fortawesome/free-solid-svg-icons";

const MatchInLive = ({match, competitionName}) => {

    const classes =  oldStyle()
  
    const dispatch = useDispatch()
  
    const theme = useTheme();
      const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  
    const [value, setValue] = useState(0);
  
    function verifieExpression(expression) {
      // Mettre l'expression en minuscules et enlever les accents
      expression = expression.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    
      // Définir les tests de regex
      const regexTests = [
        /r[eéèêë]gional/i,
        /d[eéèêë]partemental/i,
        /s[eéèêë]niors/i,
        /[Uu][0-9]{2}/
      ];
    
      // Vérifier si l'expression correspond à l'un des tests
      for (const regexTest of regexTests) {
        if (regexTest.test(expression)) {
          return true;
        }
      }
    
      // Si aucun des tests n'est valide, renvoyer false
      return false;
    }
  
    useEffect(() => {
      // TODO CONTROL NO LOAD
      if(!match.isComplete && match.type !== 'actu')
        dispatch(getMatchDetail(match.idMatch))
    }, [,match])
  
    useEffect(() => {
      if(verifieExpression(competitionName)){
        setValue(1)
      }
    }, [competitionName])
  
    useEffect(() => {
      if(match.type === 'actu')
        setValue(1)
      else{
        if(isDisabled('gamefact')){
          setValue(1)
        }
      }

    }, [match])

    const isDisabled = useCallback((onglet) => {
      // On récupère l'attribut 'subscription' de chaque team et on récupère le plus élevé
      const homeSubscription = match.homeTeam.subscription ?? 1
      const awaySubscription = match.awayTeam.subscription ?? 1

      const subscription = Math.min(homeSubscription, awaySubscription)

      switch(onglet){
        case 'import' :
          if(subscription >= 2)
            return true
          break
        case 'gamefact' :
          if(subscription >= 3)
            return true
          break
        case 'historique' :
          if(subscription >= 4)
            return true
          break
        case 'feuillematch' : 
          if(subscription >= 4)
            return true
          break
        default :
          return false
      }

      return false
    }, [match])
  
    const [activeGameFact, setActiveGameFact] = useState()
    const [open, setOpen] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
  
    const [surchargePeriod, setSurchargePeriod] = useState(undefined)
  
    const [localTimer, setLocalTimer] = useState(match.timer)
  
    const goToGameFact = () => {
      setValue(0)
    }
  
    const resetSurchargePeriod = (surchargePeriod) => {
      setSurchargePeriod(surchargePeriod)
    }
  
    useEffect(() => {

      let surchargePeriod = match.period;

      if(['handball'].includes(match.discipline)){
        surchargePeriod = getSurchargePeriod(match.discipline, match.period) || match.period;
      }

      resetSurchargePeriod(surchargePeriod)
    },[,match.period])
  
  
    const handleOpen = () => {setOpen(true); handleCloseInfo()};
    const handleClose = () => setOpen(false);
  
    const handleOpenInfo = () => {setOpenInfo(true); handleClose()};
    const handleCloseInfo = () => setOpenInfo(false);
  
    const enterGameFact = (id, defaultDetail, callback) => {
      setActiveGameFact({id, defaultDetail, callback})
    }
  
    const leaveGameFact = () => {
      setActiveGameFact(undefined)

      if(isDisabled('gamefact')){
        setValue(1)
      }
    }
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    const style = {
      position: 'absolute',
      width : '60%',
      height : '800px',
      overflow : 'auto',
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      p: 4,
    };
  
      // TODO CONTROL NO LOAD
      if(!match.isComplete && match.type !== 'actu')
        return <CircularProgress/>
  
    return (
      <Box sx={{display : 'flex', alignItems : 'center', flexDirection : 'column'}}>
        <LiveHeader match={match} enterGameFact={enterGameFact} surchargePeriod={surchargePeriod} setSurchargePeriod={setSurchargePeriod} setLocalTimer={setLocalTimer} goToGameFact={goToGameFact}/>
  
        <div style={{width : '100%', display : 'flex', justifyContent : 'space-evenly'}}>
          <Button sx={{margin : 'auto'}} variant="contained" onClick={openInfo ? handleCloseInfo : handleOpenInfo}>{openInfo ? 'Fermer' : 'Info match'}</Button>
          <Button sx={{margin : 'auto'}} variant="contained" onClick={open ? handleClose : handleOpen}  disabled={isDisabled('feuillematch')}>{open ? 'Fermer' : 'Feuille de match'}</Button>
        </div>
        
        <Box sx={{ width: '100%', padding :  0, position : 'relative'}}>
            {!open && !openInfo ? <>
              
            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
  
            {isSmall ?
              <ButtonGroup sx={{ width: '100%', padding :  0, position : 'relative', display : 'flex', flexDirection : 'column', justifyContent : 'space-around', background : '#1565c0'}} variant="contained" aria-label="outlined primary button group">
                <Box>
                  <Button sx={{whiteSpace : 'nowrap', width : '50%'}} onClick={() => setValue(0)} disabled={isDisabled('gamefact')}>Faits de jeux</Button>
                  <Button sx={{whiteSpace : 'nowrap', width : '50%'}} onClick={() => setValue(1)}>Saisie rapide</Button>
                </Box>
                <Box>
                <Button sx={{whiteSpace : 'nowrap', width : '50%'}} onClick={() => setValue(2)} disabled={isDisabled('import')}>Import</Button>
                <Button sx={{whiteSpace : 'nowrap', width : '50%'}} onClick={() => setValue(3)} disabled={isDisabled('historique')}>Historique</Button>
                </Box>
              </ButtonGroup> 
            : 
            <ButtonGroup sx={{ width: '100%', padding :  0, position : 'relative', display : 'flex', justifyContent : 'space-around', background : '#1565c0'}} variant="contained" aria-label="outlined primary button group">
                <Button sx={{whiteSpace : 'nowrap', width : '25%', '&:disabled': { backgroundColor : 'gray'}}} onClick={() => setValue(0)} disabled={isDisabled('gamefact')}>Faits de jeux</Button>
                <Button sx={{whiteSpace : 'nowrap', width : '25%', '&:disabled': { backgroundColor : 'gray'}}} onClick={() => setValue(1)}>Saisie rapide</Button>
                <Button sx={{whiteSpace : 'nowrap', width : '25%', '&:disabled': { backgroundColor : 'gray'}}} onClick={() => setValue(2)} disabled={isDisabled('import')}>Import</Button>
                <Button sx={{whiteSpace : 'nowrap', width : '25%', '&:disabled': { backgroundColor : 'gray'}}} onClick={() => setValue(3)} disabled={isDisabled('historique')}>Historique</Button>
              </ButtonGroup>}
            </Box>
            <TabPanel value={value} index={0} className={classes.tab}>
              {activeGameFact ? <GameFact gameFact={{type : activeGameFact.id, detail : {timer : Math.ceil(localTimer / 60), period : surchargePeriod, ...activeGameFact.defaultDetail}}} callback={activeGameFact.callback} endProcess={leaveGameFact} match={match} surchargePeriod={surchargePeriod}/> : 
                <GameFactFilter match={match} enterGameFact={enterGameFact} surchargePeriod={surchargePeriod} />}
            </TabPanel>
            <TabPanel value={value} index={1} className={classes.tab}>
                <LiveSaisieRapide match={match} surchargePeriod={surchargePeriod}/>
            </TabPanel>
            <TabPanel value={value} index={2} className={classes.tab}>
                <LiveImport match={match}/>
            </TabPanel>
            <TabPanel value={value} index={3} className={classes.tab}>
                <LiveHistorique match={match}/>
            </TabPanel>
            </>
            :
            <>
              {open && <FeuilleMatchCreation match={match} close={handleClose}/>}
              {openInfo && <InfoMatchCreation match={match} close={handleCloseInfo}/>}
            </>
            //
            
            }
        </Box>
  
        
      </Box>
    )
  }

  export const InfoMatchCreation = ({match, close}) => {
    const dispatch = useDispatch()

    const classes =  useStyles();
  
    const [infoData, setInfoData] = useState({referee : match.referee, stade : match.stade, nbSpec : match.nbSpec, grass : match.grass, weather : match.weather})
  
    const [src, setSrc] = useState(null)
    const [crop, setCrop] = useState({ 
      unit : 'px',
      width : 573,
      height : 300});
    const [image, setImage] = useState(null);
    const [base64, setBase64] = useState(null);
    const [output, setOutput] = useState(null);
  
    const selectImage = (file) => {
      setSrc(URL.createObjectURL(file));
      setImage(null)
    };
  
    function dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);
  
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  
      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
  
      //New Code
      return new Blob([ab], {type: mimeString});
  
  
  }
  
    const cropImageNow = () => {
      const canvas = document.createElement('canvas');
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');
    
      const pixelRatio = window.devicePixelRatio;
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = 'high';
  
      if(!crop.x)
        crop.x = 0
  
      if(!crop.y)
        crop.y = 0
    
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height,
      );
        
      // Converting to base64
      const base64Image = canvas.toDataURL('image/jpeg');
      setBase64(base64Image)
  
      const myBlob = dataURItoBlob(base64Image)
      setOutput(myBlob)
    };
  
    const loadedImage = (e) => {
      setImage(e.target)
    }
  
    useEffect(() => {
      let ratio = 300 / 573
      if(image){
        setCrop({ 
          unit : 'px',
          width : image.width,
          height : image.width * ratio
        })
      }

    }, [image])

    useEffect(() => {
      if(image)
        cropImageNow()

    }, [crop])
  
    const submit = () => {
      const {referee, stade, nbSpec, grass, weather} = infoData
      dispatch(updateInfoMatch(match.idMatch, {
        referee : referee,
        stade : stade,
        nbSpec : nbSpec,
        grass : grass,
        weather : weather,
        image : output,
        provider : match.provider,
      }, 'composition'))
  
      setSrc(null)
      setImage(null)
      setOutput(null)
      setBase64(null)
  
      close()
    }
  
    return (
      <>
        <Grid container style={{display : 'flex', justifyContent : 'space-evenly', marginTop : 20}}>
          <Grid item xs={12} sm={6} sx={{mb : 2}}>
            <Box className='medium-padding'>
              <TextField fullWidth className={classes.customInput} label="Arbitre" variant="outlined" onChange={(e) => setInfoData(s => ({...s, referee : e.target.value}))} value={infoData.referee}></TextField>
                <br/>
              <TextField fullWidth className={classes.customInput} style={{marginTop : 10}} label="Stade" variant="outlined" onChange={(e) => setInfoData(s => ({...s, stade : e.target.value}))} value={infoData.stade}></TextField>
                <br/>
              <TextField fullWidth className={classes.customInput} style={{marginTop : 10}} type="number" label="Spectateurs" variant="outlined" onChange={(e) => setInfoData(s => ({...s, nbSpec : e.target.value}))} value={infoData.nbSpec}></TextField>
                <br/>
              {
                ["soccer", "rugby"].includes(match.discipline) && 
                <>
                  <TextField fullWidth className={classes.customInput} style={{marginTop : 10}} type="text" label="Pelouse" variant="outlined" onChange={(e) => setInfoData(s => ({...s, grass : e.target.value}))} value={infoData.grass}></TextField>
                    <br/>
                  <TextField fullWidth className={classes.customInput} style={{marginTop : 10}} type="text" label="Météo" variant="outlined" onChange={(e) => setInfoData(s => ({...s, weather : e.target.value}))} value={infoData.weather}></TextField>
                </>
              }
              
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box className='medium-padding'>
            <img style={{fill : 'contain'}} src={base64 ?? match.imageUrl ?? (match.discipline==='handball' ? background_handball : background)} width={'100%'}/>
              </Box>
               <Box className='centered-wrapper'>
                      <DsasButton 
                      icon={faImage}
                      label='Charger une image'
                      variant="secondary" 
                      upload={true} 
                      onChange={(e) => {
                        selectImage(e.target.files[0]);
                      }}
                    />
              </Box>  

          </Grid>
          
          
        </Grid>

        {/*IMAGE CROP ZONE*/}
            {src && (
              <Box className="medium-padding centered-wrapper">
                <ReactCrop aspect={573 / 300}
                  crop={crop} onChange={c => setCrop(c)} onComplete={cropImageNow} >
                    <img src={src} onLoad={loadedImage} alt='crop-zone'/>
                </ReactCrop>
              </Box>
            )}
  
        <Box className='centered-medium-wrapper'>    
        <DsasButton 
                      label='Valider'
                      variant="alternative" 
                      onClick={submit}
                       />
  
        </Box>
      </>
    )
  }
  

  export default MatchInLive